import { ReloadOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

/**
 * Последний рубеж: исключение в рендере не должно оставлять оператора перед
 * белым экраном без единой подсказки, что делать.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Необработанная ошибка рендера", error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error === null) return this.props.children;
    return (
      <Result
        status="error"
        title="Что-то сломалось"
        subTitle={this.state.error.message}
        extra={
          <Button
            type="primary"
            icon={<ReloadOutlined aria-hidden />}
            onClick={() => {
              window.location.reload();
            }}
          >
            Перезагрузить
          </Button>
        }
      />
    );
  }
}
